class HomepageReviewCarousel extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-review-image]').forEach((image) => {
      const hideMedia = () => {
        const media = image.closest('[data-review-media]');
        const card = image.closest('[data-review-card]');
        if (media) media.hidden = true;
        if (card) card.classList.add('is-image-missing');
      };

      image.addEventListener('error', hideMedia, { once: true });
      if (image.complete && image.naturalWidth === 0) hideMedia();
    });
  }
}

if (!customElements.get('homepage-review-carousel')) {
  customElements.define('homepage-review-carousel', HomepageReviewCarousel);
}
